// Warning: code called directly after this function may or may not still execute:

import useLoginStatusStore from '../zustandStore/loginStatusStore';
import { clearApplicationStorage, saveRedirectUrl } from './localStorage';

// Global flag to prevent multiple simultaneous logout calls
let isLoggingOut = false;

// https://stackoverflow.com/questions/10525584/what-happens-to-code-after-a-javascript-redirect-setting-window-location-href
const logOut = (sessionExpired = false, isAccountDeleted = false) => {
	// Prevent multiple concurrent logout calls (e.g., from multiple failed API requests)
	if (isLoggingOut) return;
	isLoggingOut = true;

	clearApplicationStorage();

	const { location } = window;
	const redirectUrl = `${location.pathname}${location.search}`;
	saveRedirectUrl(redirectUrl);

	// Build URL with query params (fix bug where second assignment overwrites first)
	let url = '/';
	if (sessionExpired) url += '?sessionExpired=true';
	else if (isAccountDeleted) url += '?isAccountDeleted=true';

	window.location.href = url;

	useLoginStatusStore.getState().setLoggedIn(false);
};

export default logOut;
